import { render, staticRenderFns } from "./layer.vue?vue&type=template&id=3f521a46&scoped=true"
import script from "./layer.vue?vue&type=script&lang=js"
export * from "./layer.vue?vue&type=script&lang=js"
import style0 from "./layer.vue?vue&type=style&index=0&id=3f521a46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f521a46",
  null
  
)

export default component.exports